import { gql } from '../../__generated__'

export const GET_PROFILE = gql(/* GraphQL */ `
  query GetProfile {
    users {
      id
      name
      email
      admin {
        id
        createdAt
      }
    }
  }
`)

export const UPDATE_USER_NAME = gql(/* GraphQL */ `
  mutation UpdateUserName($where: UserWhereUniqueInput!, $data: UserUpdateInput!) {
    updateUser(where: $where, data: $data) {
      id
      name
    }
  }
`)
